import React, { useState } from 'react';
import {
  Box,
  Container,
  Heading,
  Input,
  Button,
  VStack,
  Text,
  useToast,
  Image,
  Link,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const Home = () => {
  const [url, setUrl] = useState('');
  const [shortUrl, setShortUrl] = useState('');
  const [qrCode, setQrCode] = useState('');
  const toast = useToast();

  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isAuthenticated) {
      toast({
        title: 'Authentication Required',
        description: 'Please login to create shortened URLs',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      navigate('/login');
      return;
    }

    // Validate URL
    let urlToShorten = url.trim();
    if (!urlToShorten.match(/^https?:\/\//i)) {
      urlToShorten = 'https://' + urlToShorten;
    }

    try {
      const token = localStorage.getItem('token');
      const res = await axios.post('http://localhost:5000/api/url/shorten', {
          originalUrl: urlToShorten
        }, {
          headers: {
            'x-auth-token': token
          }
        });
      setShortUrl(`http://localhost:5000/api/url/${res.data.url.shortUrl}`);
      setQrCode(res.data.qrCode);
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8}>
        <Heading>URL Shortener</Heading>
        <Box w="100%" as="form" onSubmit={handleSubmit}>
          <VStack spacing={4}>
            <Input
              placeholder="Enter your URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              size="lg"
            />
            <Button type="submit" colorScheme="teal" size="lg" w="100%">
              Shorten URL
            </Button>
          </VStack>
        </Box>
        {shortUrl && (
          <VStack spacing={4} w="100%">
            <Text fontSize="lg">Your shortened URL:</Text>
            <Box
              p={4}
              bg="gray.100"
              borderRadius="md"
              w="100%"
              wordBreak="break-all"
            >
              <Link
                color="teal.500"
                href={shortUrl}
                onClick={async (e) => {
                  e.preventDefault();
                  const shortId = shortUrl.split('/').pop();
                  window.open(shortUrl, '_blank');
                  try {
                    await axios.post(`http://localhost:5000/api/url/${shortId}/increment`);
                  } catch (error) {
                    console.error('Error incrementing click count:', error);
                  }
                }}
                isExternal
              >
                {shortUrl}
              </Link>
            </Box>
            {qrCode && (
              <Box>
                <Text fontSize="lg" mb={2}>QR Code:</Text>
                <Image src={qrCode} alt="QR Code" />
              </Box>
            )}
          </VStack>
        )}
      </VStack>
    </Container>
  );
};

export default Home;
